// AUTO GENERATED FILE - Changes WILL be lost.
export const translations = {}
